import { User } from 'utilities'
import { UserRequest } from './InviteUserStore.types'

export const getInitialUserRequest = (): UserRequest => {
  return {
    id: null,
    emailAddress: '',
    organizationId: User.organization ? User.organization.id : null,
    organizationName: User.organization ? User.organization.name : null,
    skipInvitationEmail: false,
    roles: []
  }
}
